// Externals
import React, { useEffect, useState } from "react";

// Assets
import LocationIcon from "../../static/svg/location-icon.svg";

// Scss
import "./Postcode.scss";

const validPostcode = /^[0-9\b]+$/;

const Postcode = ({
	onPostcodeChange,
	onDontLiveInAustraliaChange,
	dontLiveInAustralia,
	value,
}) => {
	const GOOGLE_MAP_API_KEY = "AIzaSyDld85aLNnB-2th4uf3arcdZPj57yOJ_bk";

	// States
	const [inputValue, setInputValue] = useState("");

	// useEffects
	useEffect(() => {
		onPostcodeChange(inputValue);
	}, [inputValue, onPostcodeChange]);

	useEffect(() => {
		if (value) {
			setInputValue(value);
		}
	}, [value]);

	useEffect(() => {
		if (dontLiveInAustralia) {
			setInputValue("");
		}
	}, [dontLiveInAustralia]);

	const getUserCurrentLatAndLong = () => {
		if (!dontLiveInAustralia) {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(function (position) {
					var countries = ["AU"];
					return fetch(
						`https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=${GOOGLE_MAP_API_KEY}`,
					)
						.then((response) => response.json())
						.then((data) => {
							if (data.status === "OK") {
								let postal_code, country;
								for (
									let i = 0;
									i <
									data.results[0].address_components.length;
									i++
								) {
									for (
										let j = 0;
										j <
										data.results[0].address_components[i]
											.types.length;
										j++
									) {
										switch (
											data.results[0].address_components[
												i
											].types[j]
										) {
											case "postal_code":
												postal_code =
													data.results[0]
														.address_components[i]
														.long_name;
												break;
											case "country":
												country =
													data.results[0]
														.address_components[i]
														.short_name;
												break;
											default:
												break;
										}
									}
								}

								if (countries.includes(country)) {
									setInputValue(postal_code);
								} else {
									setInputValue("");
									onDontLiveInAustraliaChange();
								}
							}
						})
						.catch((err) => console.warn(err.message));
				});
			} else {
				//alert("Sorry, your browser does not support HTML5 geolocation.");
				return false;
			}
		}
	};

	return (
		<div className="postcode">
			<input
				type="text"
				placeholder="Postcode"
				onChange={(e) => {
					if (
						(e.target.value === "" ||
							validPostcode.test(e.target.value)) &&
						e.target.value.length < 5
					) {
						setInputValue(e.target.value);
					}
				}}
				value={inputValue}
				data-cy={"input-postcode"}
				disabled={dontLiveInAustralia === true ? true : false}
			/>
			<div className="icon-wrapper" onClick={getUserCurrentLatAndLong}>
				<img src={LocationIcon} alt="location-icon" />
			</div>
		</div>
	);
};

export default Postcode;

// Example
// Lat: -33.878520
// Long: 151.221120
